// Route href vocabulary of the Closing edit drawer (`closing-new/<sectionHref>`), kept
// import-light so non-page consumers (e.g. the loanNavigation service) can read the route
// contract without pulling the drawer's component tree (mirrors EditModal.hrefs).
// EditDrawer.config re-exports it.
export const SECTION_HREF_MAP = {
  SCHEDULING: 'scheduling-information',
  TITLE_COMPANY: 'title-company',
  CLOSING_FUNDING_DATES: 'closing-funding-dates',
  FUNDING_INFORMATION: 'funding-information',
  MANUFACTURED_HOME_CONTACTS: 'manufactured-home-contacts',
  TITLE_HOLDER: 'title-holder',
};
